import footer2 from "../../assets/footer/449677597_872889524863608_2428981879680023926_n.jpg";
import footer3 from "../../assets/footer/449721333_874844368001457_3171823311286213279_n.jpg";
import footer4 from "../../assets/footer/449159036_867844852034742_1504046044458294720_n.jpg";
import footer5 from "../../assets/footer/449055035_867093618776532_4642504549368631600_n.jpg";
import footer6 from "../../assets/footer/448791744_863895555763005_7434958030116741059_n.jpg";
import footer1 from "../../assets/footer/387861504_122130745322017259_8979535170336969575_n.jpg";

export const footerImgae = [
  footer1,
  footer2,
  footer3,
  footer4,
  footer5,
  footer6,
];
